import { SEQUENCE_STATUS_IDS } from 'features/bulk-email/sequences/constants';
import { THEME } from 'GlobalStyles';

export const SEQUENCE_LIST_STATUSES_COLORS_BY_ID = {
  [SEQUENCE_STATUS_IDS.pending]: THEME.palette.warning.main,
  [SEQUENCE_STATUS_IDS.inProgress]: THEME.palette.info.dark,
  [SEQUENCE_STATUS_IDS.completed]: THEME.palette.success.dark,
  [SEQUENCE_STATUS_IDS.canceled]: THEME.palette.grey.A700,
  defualt: THEME.palette.grey.black
};

export const SEQUENCE_CHIP_COLOR = THEME.palette.primary.light;
